export const getStrictSearch = ({ offer, promocode, roomType } = {}) =>
  offer === undefined && promocode === undefined && roomType === undefined
    ? undefined
    : offer === true || promocode === true || roomType === true;
